<template>
  <div class="content">
    <h1 class="has-text-centered">Spezifische Widerstände</h1>
    <div class="box">
      <p>Spezifischer Widerstand ausgewählter Materialien bei 20 °C.</p>
      <p>
        <font-awesome-icon icon="arrow-circle-right" />
        <a href="https://de.wikipedia.org/wiki/Spezifischer_Widerstand#Spezifischer_Widerstand_verschiedener_Materialien" target="_blank" class="pl-2">Wikipedia-Artikel</a>
      </p>
      <div class="has-overflow-x-auto mb-3">
        <table class="table is-hoverable is-striped is-fullwidth">
          <thead>
            <tr>
              <th>Material</th>
              <th>
                Spezifischer Widerstand (
                <span v-katex="'\\rho'"></span>
                ) in &ohm; * mm
                <sup>2</sup>
                /m
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Aluminium</td>
              <td>2,65 * 10<sup>-2</sup></td>
            </tr>
            <tr>
              <td>Bernstein</td>
              <td>1 * 10<sup>22</sup></td>
            </tr>
            <tr>
              <td>Blei</td>
              <td>2,08 * 10<sup>-1</sup></td>
            </tr>
            <tr>
              <td>Edelstahl</td>
              <td>7,2 * 10<sup>-1</sup></td>
            </tr>
            <tr>
              <td>Eisen</td>
              <td>1,0 * 10<sup>-1</sup> bis 1,5 * 10<sup>-1</sup></td>
            </tr>
            <tr>
              <td>Germanium</td>
              <td>5 * 10<sup>5</sup></td>
            </tr>
            <tr>
              <td>Glas</td>
              <td>1 * 10<sup>16</sup> bis 1 * 10<sup>21</sup></td>
            </tr>
            <tr>
              <td>Gold</td>
              <td>2,214 * 10<sup>-2</sup></td>
            </tr>
            <tr>
              <td>Graphit</td>
              <td>8 * 10<sup>0</sup></td>
            </tr>
            <tr>
              <td>Gummi (Hartgummi) (Werkstoff)</td>
              <td>1 * 10<sup>19</sup></td>
            </tr>
            <tr>
              <td>Holz (trocken)</td>
              <td>1 * 10<sup>10</sup> bis 1 * 10<sup>16</sup></td>
            </tr>
            <tr>
              <td>Kohlenstoff</td>
              <td>3,5 * 10<sup>1</sup></td>
            </tr>
            <tr>
              <td>Kupfer (rein, "IACS")</td>
              <td>1,721 * 10<sup>-2</sup></td>
            </tr>
            <tr>
              <td>Kupfer (Elektro-Kabel)</td>
              <td>1,69 * 10<sup>-2</sup> bis 1,75 * 10<sup>-2</sup></td>
            </tr>
            <tr>
              <td>Magnesium</td>
              <td>4,39 * 10<sup>-2</sup></td>
            </tr>
            <tr>
              <td>Messing</td>
              <td>7 * 10<sup>-2</sup></td>
            </tr>
            <tr>
              <td>Nickel</td>
              <td>6,93 * 10<sup>-2</sup></td>
            </tr>
            <tr>
              <td>Papier</td>
              <td>1 * 10<sup>15</sup> bis 1 * 10<sup>17</sup></td>
            </tr>
            <tr>
              <td>Platin</td>
              <td>1,05 * 10<sup>-1</sup></td>
            </tr>
            <tr>
              <td>Porzellan</td>
              <td>1 * 10<sup>18</sup></td>
            </tr>
            <tr>
              <td>Quarzglas</td>
              <td>7,5 * 10<sup>23</sup></td>
            </tr>
            <tr>
              <td>Schwefel</td>
              <td>1 * 10<sup>21</sup></td>
            </tr>
            <tr>
              <td>Silber</td>
              <td>1,587 * 10<sup>-2</sup></td>
            </tr>
            <tr>
              <td>Stahl</td>
              <td>1 * 10<sup>-1</sup> bis 2 * 10<sup>-1</sup></td>
            </tr>
            <tr>
              <td>Titan</td>
              <td>8 * 10<sup>-1</sup></td>
            </tr>
            <tr>
              <td>Wasser (reinst)</td>
              <td>1 * 10<sup>12</sup></td>
            </tr>
            <tr>
              <td>Wasser (typ. Leitungswasser)</td>
              <td>2 * 10<sup>7</sup></td>
            </tr>
            <tr>
              <td>Wasser (typ. Meerwasser)</td>
              <td>5 * 10<sup>5</sup></td>
            </tr>
            <tr>
              <td>Wolfram</td>
              <td>5,28 * 10<sup>-2</sup></td>
            </tr>
            <tr>
              <td>Zinn</td>
              <td>1,09 * 10<sup>-1</sup></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tables-electrical-resistivity',
  metaInfo: {
    title: 'Spezifische Widerstände Tabelle | Elektrotechik-Rechner.at',
    meta: [
      {
        name: 'description',
        content: 'Der spezifische Widerstand ist eine Materialkonstante die den Widerstand eines elektrischen Leiters mitbestimmt.'
      }
    ]
  },
  created () {
    this.$store.commit('updateNavTitle', { title: '<span class="fas fa-angle-left"></span> Zurück', route: 'tables' })
  }
}
</script>
